import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.autoClose()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  close(event) {
    if (event) event.preventDefault()
    this.fadeOut()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  autoClose() {
    this.timeout = setTimeout(() => {
      this.fadeOut()
    }, 3200)
  }

  fadeOut() {
    if (this.closing) return
    this.closing = true

    this.element.classList.add("opacity-0", "pointer-events-none")
    this.panelTarget.classList.add("scale-95")

    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
